import { onEnter } from '@susu/custom-made/utils/utils';

import styles from './cardListInStore.module.scss';

export default function CardListInStore({
  scanClick,
  searchClick,
}: Readonly<{
  scanClick: () => void;
  searchClick: () => void;
}>) {
  return (
    <>
      <div
        className={styles.container}
        data-test-id="scan-card"
        onClick={scanClick}
        onKeyDown={e => {
          onEnter(e, () => {
            scanClick();
          });
        }}
      >
        <div className={styles.content}>
          <i className="susu-icons" translate="no">
            scan
          </i>
        </div>
        <div className={styles.textContainer}>
          <div className={styles.text}>Scan</div>
        </div>
      </div>
      <div
        className={styles.container}
        data-test-id="search-card"
        onClick={searchClick}
        onKeyDown={e => {
          onEnter(e, () => {
            searchClick();
          });
        }}
      >
        <div className={styles.content}>
          <i className="susu-icons" translate="no">
            search
          </i>
        </div>
        <div className={styles.textContainer}>
          <div className={styles.text}>Search</div>
        </div>
      </div>
    </>
  );
}
